import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { PhoneBookData } from "../meta/PhoneBookData.interface";
import { INITIAL_PHONEBOOK_DATA } from "../meta/initial-phonebook-data.const";

@Injectable({
    providedIn: "root"
})
export class PhoneBookService {

    private readonly _phoneBookData$ = new BehaviorSubject<PhoneBookData>(INITIAL_PHONEBOOK_DATA)
    public readonly phoneBookData$ = this._phoneBookData$.asObservable()

    public getPhoneBookData(): PhoneBookData {
        return this._phoneBookData$.getValue()
    }
    
    public setPortingData(phoneBookData: Partial<PhoneBookData>): void {
        this._phoneBookData$.next({
            ...this._phoneBookData$.getValue(),
            ...phoneBookData
        })
    }
    
}
